// extracted by mini-css-extract-plugin
module.exports = {"ModalWrapper":"Modal_ModalWrapper__3G7Rn","Overlay":"Modal_Overlay__21j6m","Container":"Modal_Container__37bDZ","slide":"Modal_slide__lmUIx"};